import { GrowAvatar } from "@sinecycle/growcomponents";
import { Avatar } from "antd";

interface AvatarProps {
  namesProps: Omit<
    React.ComponentProps<typeof GrowAvatar.Names>,
    "colorIndex" | "initials"
  >;
  name: string | string[];
}

function AntAvatar(props: AvatarProps) {}

function AvatarNames(props: AvatarProps) {
  function getChars(names: string[]) {
    return names.join(" ").length;
  }

  function getInitials(names: string[]) {
    return names
      .filter((name) => name)
      .reduce(
        (finalString, currentName) =>
          finalString.concat(currentName.charAt(0)).toUpperCase(),
        ""
      )
      .trim();
  }
  return (
    <GrowAvatar.Names
      {...props.namesProps}
      colorIndex={
        Array.isArray(props.name)
          ? getChars(props.name)
          : getChars([props.name])
      }
      initials={
        Array.isArray(props.name)
          ? getInitials(props.name)
          : getInitials([props.name])
      }
    />
  );
}

AntAvatar.Names = AvatarNames;
AntAvatar.Image = Avatar;
export { AntAvatar as Avatar };
